/* eslint-disable @typescript-eslint/no-unused-vars */
//import { Link, useLocation } from "react-router-dom";
//import menu from "../../assets/img/menu.png";
//import Search from "./Search";
//import SearchMobile from "./Filter/SearchMobile";
//import Search from "./Filter/Search";
//import User from "./user/User";

import {
  Search,
  MapPin,
  Users,
  CalendarDays,
  Minus,
  Plus,
  Send,
} from "lucide-react";
import { Button } from "./Button";
import { Input } from "./Input";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
import { Calendar as CalendarComponent } from "./Calendar";
import { useState, useRef, useEffect } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { Link, useSearchParams } from "react-router-dom";
import logoMobil from "../../assets/isologo.svg";
import logo from "../../assets/img/logo-en-blanco.webp";
import { useAppContext } from "../../contexts/AppProvider";
import Filter from "./Filter/Filter";
import AddUser from "./user/AddUser";
import User from "./user/User";
import { URL_API } from "../../config/default";
import { useQuery } from "@tanstack/react-query";
import { Drawer } from "flowbite-react";

const Header = () => {
  const [searchParams] = useSearchParams();
  const { me }: any = useAppContext();
  const [destination, setDestination] = useState(searchParams.get("location"));
  const [checkIn, setCheckIn] = useState<any>(searchParams.get("startDate"));
  const [checkOut, setCheckOut] = useState<any>(searchParams.get("endDate"));
  const [guest, setGuest] = useState<any>(searchParams.get("travellers") ?? 0);
  const [showDestinations, setShowDestinations] = useState(false);
  const [showCheckIn, setShowCheckIn] = useState(false);
  const [showCheckOut, setShowCheckOut] = useState(false);
  const [showGuests, setShowGuests] = useState(false);
  const [searchLocations, setSearchLocations] = useState<any>("");
  const abortControllerRef = useRef<AbortController | null>(null);
  const [coordinates, setCoordinates] = useState<[number, number] | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);

  // Detectar tamaño de pantalla
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleSearch = () => {
    if (destination && destination !== 'En mi zona') searchParams.set("location", destination);

    if (destination == 'En mi zona' && coordinates && coordinates?.length > 0) {
      searchParams.set("lat", String(coordinates[0]));
      searchParams.set("lon", String(coordinates[1]));
    }

    if (checkIn) searchParams.set("startDate", checkIn);
    if (checkOut) searchParams.set("endDate", checkOut);

    searchParams.set("travellers", String(guest));

    const queryString = searchParams.toString();
    const redirectUrl = `/alojamientos?${queryString}`;

    // Cerrar el modal móvil si está abierto
    if (isMobile) {
      setShowMobileSearch(false);
    }

    window.location.href = redirectUrl;
  };

  const handleDestinationSelect = (dest: string) => {
    if (dest == 'En mi zona') {
      if (typeof window === "undefined" || !navigator.geolocation) {
        console.error("Geolocalización no soportada o ejecutándose en servidor");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => setCoordinates([position.coords.latitude, position.coords.longitude]),
        (error) => console.error("Error obteniendo la ubicación:", error),
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
      setShowDestinations(false);
      setDestination(dest);
      return '';
    }
    setDestination(dest);
    setShowDestinations(false);
  };

  const handleCheckInSelect = (date: Date | undefined) => {
    setCheckIn(date);
    if (date && checkOut && date >= checkOut) {
      setCheckOut(undefined);
    }
    setShowCheckIn(false);
  };

  const handleCheckOutSelect = (date: Date | undefined) => {
    setCheckOut(date);
    setShowCheckOut(false);
  };

  const { data: locations } = useQuery({
    queryKey: ["locations", searchLocations],
    queryFn: () => {
      const abortController = new AbortController();
      abortControllerRef.current = abortController;
      if (searchLocations.trim() !== '') {
        return fetch(`${URL_API}/locations/${searchLocations}`, { signal: abortController.signal }
        ).then((res) => res.json());
      }
      return null
    },
  });



  return (
    <header className="bg-gradient-left text-white sticky top-0 z-50 shadow-lg">
      <div className="mx-auto lg:px-[150px] lg:py-4">
        <div
          className="
        grid
        grid-cols-1
        md:grid-cols-1
        lg:grid-cols-1
        items-center
        lg:gap-4
      "
        >

          {/* Enhanced Search Bar */}
          <div className="flex w-full px-3 gap-2">
            <div className="lg:w-full flex justify-start items-center">
              <Link
                to="/"
                className="no-underline lg:w-[150px] w-[90px] hidden lg:flex"
                style={{ color: "unset" }}
              >
                <img src={logo} className="lg:w-[150px] w-[90px]" alt="logo" />
              </Link>
            </div>

            <div className="lg:hidden w-[50px] flex justify-start items-center">
              <Link
                to="/"
                className="no-underline w-[70px]"
                style={{ color: "unset" }}
              >
                <img src={logoMobil} className="w-[40px]" alt="logo" />
              </Link>
            </div>

            {/* Mobile Search Button */}
            {isMobile && (
              <div className="w-full flex justify-center  items-center py-5 lg:py-3">
                <button
                  onClick={() => setShowMobileSearch(true)}
                  className="flex  btn bg-white text-[#8B9456] hover:bg-gray-100 text-sm font-medium w-full h-full"
                  style={{ borderRadius: "30px" }}
                >
                  <span className="flex items-center justify-center">
                    <Search className="w-4 h-4 me-4" />
                    Buscar
                  </span>
                </button>
              </div>
            )}

            {
              !isMobile && (
                <div className="hidden lg:flex bg-white rounded-full shadow-lg p-2 flex items-center gap-1">
                  {/* Lugar con Autocompletado */}
                  <Popover
                    open={showDestinations}
                    onOpenChange={setShowDestinations}
                  >
                    <PopoverTrigger asChild>
                      <div className="flex-1 min-w-0 px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-full transition-colors">
                        <div className="flex items-center gap-2">
                          <MapPin className="w-4 h-4 text-gray-400 flex-shrink-0" />
                          <div className="min-w-0">
                            <div className="text-xs font-medium text-gray-900">
                              Lugar
                            </div>
                            <div className="text-sm text-gray-600 truncate">
                              {destination || "Explorar destinos"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </PopoverTrigger>
                    <PopoverContent className="w-80 p-0" align="start">
                      <div className="p-4">
                        <Input
                          placeholder="¿A dónde quieres ir?"
                          value={searchLocations}
                          onChange={(e) => setSearchLocations(e.target.value)}
                          className="mb-4"
                          autoFocus
                        />
                        <div className="space-y-1 max-h-60 overflow-y-auto">
                          {locations ? (
                            <>
                              <h4 className="font-medium text-sm text-gray-900 mb-2">
                                {destination ? "Resultados" : "Destinos populares"}
                              </h4>
                              {locations.map((dest: any, index: any) => (
                                <button
                                  key={index}
                                  onClick={() => handleDestinationSelect(dest.location)}
                                  className="w-full text-left px-3 py-2 hover:bg-gray-100 rounded-lg text-sm flex items-center gap-2 transition-colors"
                                >
                                  <MapPin className="w-4 h-4 text-gray-400" />
                                  <span>{dest.location}</span>
                                </button>
                              ))}
                            </>
                          ) : (
                            <div className="text-center py-4 text-gray-500">
                              <button
                                onClick={() => handleDestinationSelect('En mi zona')}
                                className="w-full text-left px-3 py-2 hover:bg-gray-100 rounded-lg text-sm flex items-center gap-2 transition-colors"
                              >
                                <Send className="w-5 h-5 text-gray-400" />
                                <span className="text-2xl">En la zona</span>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </PopoverContent>
                  </Popover>

                  <div className="w-px h-8 bg-gray-200"></div>

                  {/* Check-in con DatePicker */}
                  <Popover open={showCheckIn} onOpenChange={setShowCheckIn}>
                    <PopoverTrigger asChild>
                      <div className="flex-1 min-w-0 px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-full transition-colors">
                        <div className="flex items-center gap-2">
                          <CalendarDays className="w-4 h-4 text-gray-400 flex-shrink-0" />
                          <div className="min-w-0">
                            <div className="text-xs font-medium text-gray-900">
                              Check-in
                            </div>
                            <div className="text-sm text-gray-600 truncate">
                              {checkIn
                                ? format(checkIn, "dd MMM yyyy", { locale: es })
                                : "¿Cuándo?"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0" align="start">
                      <CalendarComponent
                        mode="single"
                        selected={checkIn}
                        onSelect={handleCheckInSelect}
                        disabled={(date: any) => date < new Date()}
                        locale={es}
                      />
                    </PopoverContent>
                  </Popover>

                  <div className="w-px h-8 bg-gray-200"></div>

                  {/* Check-out con DatePicker */}
                  <Popover open={showCheckOut} onOpenChange={setShowCheckOut}>
                    <PopoverTrigger asChild>
                      <div className="flex-1 min-w-0 px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-full transition-colors">
                        <div className="flex items-center gap-2">
                          <CalendarDays className="w-4 h-4 text-gray-400 flex-shrink-0" />
                          <div className="min-w-0">
                            <div className="text-xs font-medium text-gray-900">
                              Check-out
                            </div>
                            <div className="text-sm text-gray-600 truncate">
                              {checkOut
                                ? format(checkOut, "dd MMM yyyy", { locale: es })
                                : "¿Cuándo?"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0" align="start">
                      <CalendarComponent
                        mode="single"
                        selected={checkOut}
                        onSelect={handleCheckOutSelect}
                        disabled={(date: any) => date < (checkIn || new Date())}
                        locale={es}
                      />
                    </PopoverContent>
                  </Popover>

                  <div className="w-px h-8 bg-gray-200"></div>

                  {/* Viajeros Mejorado */}
                  <Popover open={showGuests} onOpenChange={setShowGuests}>
                    <PopoverTrigger asChild>
                      <div className="flex-1 min-w-0 px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-full transition-colors">
                        <div className="flex items-center gap-2">
                          <Users className="w-4 h-4 text-gray-400 flex-shrink-0" />
                          <div className="min-w-0">
                            <div className="text-xs font-medium text-gray-900">
                              Viajeros
                            </div>
                            <div className="text-sm text-gray-600 truncate">
                              {guest === 1
                                ? "1 huésped"
                                : `${guest} huéspedes`}
                            </div>
                          </div>
                        </div>
                      </div>
                    </PopoverTrigger>
                    <PopoverContent className="w-80 p-4" align="end">
                      <div className="space-y-6">
                        {/* Adultos */}
                        <div className="flex items-center justify-between">
                          <div>
                            <div className="font-medium">Huéspedes</div>
                            <div className="text-sm text-gray-600">
                            </div>
                          </div>
                          <div className="flex items-center gap-3">
                            <Button
                              variant="outline"
                              size="icon"
                              className="h-8 w-8 rounded-full"
                              onClick={() => setGuest(Math.max(1, guest - 1))}
                              disabled={guest <= 1}
                            >
                              <Minus className="w-4 h-4" />
                            </Button>
                            <span className="w-8 text-center font-medium">
                              {guest}
                            </span>
                            <Button
                              variant="outline"
                              size="icon"
                              className="h-8 w-8 rounded-full"
                              onClick={() => setGuest(Math.min(16, guest + 1))}
                              disabled={guest >= 16}
                            >
                              <Plus className="w-4 h-4" />
                            </Button>
                          </div>
                        </div>
                        <div className="pt-4 border-t">
                          <div className="text-sm text-gray-600">
                            Total:{" "}
                            <span className="font-medium">
                              {guest}{" "}
                              {guest === 1 ? "huésped" : "huéspedes"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </PopoverContent>
                  </Popover>

                  {/* Search Button */}
                  <Button
                    onClick={handleSearch}
                    className="bg-[#8B9456] hover:opacity-50 text-white rounded-full h-12 w-12 flex-shrink-0 transition-colors"
                    size="icon"
                  >
                    <Search className="w-5 h-5" />
                  </Button>
                </div>
              )
            }

            {/* Navigation Icons */}
            <div className="lg:w-full flex items-center lg:gap-2 ">
              <div className="py-5 lg:py-3 lg:w-full flex items-center justify-end h-full">
                <Filter />
              </div>
              <div className="hidden py-3  lg:flex items-center w-full h-full justify-center">
                {me == undefined ? <AddUser /> : <User user={me} />}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Search Modal */}

      {
        isMobile && (
          <Drawer
            className="w-full"
            open={showMobileSearch}
            onClose={() => setShowMobileSearch(false)}
          >
            <Drawer.Header title="Explorar" titleIcon={() => <></>} />
            <Drawer.Items>
              <div className="bg-white p-2 items-center gap-1">
                {/* Lugar con Autocompletado */}
                <Popover
                  open={showDestinations}
                  onOpenChange={setShowDestinations}
                >
                  <PopoverTrigger asChild>
                    <div className="flex-1 min-w-0 px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-full transition-colors">
                      <div className="flex items-center gap-2">
                        <MapPin className="w-4 h-4 text-gray-400 flex-shrink-0" />
                        <div className="min-w-0">
                          <div className="text-xs font-medium text-gray-900">
                            Lugar
                          </div>
                          <div className="text-sm text-gray-600 truncate">
                            {destination || "Explorar destinos"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </PopoverTrigger>
                  <PopoverContent className="w-80 p-0" align="start">
                    <div className="p-4">
                      <Input
                        placeholder="¿A dónde quieres ir?"
                        value={searchLocations}
                        onChange={(e) => setSearchLocations(e.target.value)}
                        className="mb-4"
                        autoFocus
                      />
                      <div className="space-y-1 max-h-60 overflow-y-auto">
                        {locations ? (
                          <>
                            <h4 className="font-medium text-sm text-gray-900 mb-2">
                              {destination ? "Resultados" : "Destinos populares"}
                            </h4>
                            {locations.map((dest: any, index: any) => (
                              <button
                                key={index}
                                onClick={() => handleDestinationSelect(dest.location)}
                                className="w-full text-left px-3 py-2 hover:bg-gray-100 rounded-lg text-sm flex items-center gap-2 transition-colors"
                              >
                                <MapPin className="w-4 h-4 text-gray-400" />
                                <span>{dest.location}</span>
                              </button>
                            ))}
                          </>
                        ) : (
                          <div className="text-center py-4 text-gray-500">
                            <button
                              onClick={() => handleDestinationSelect('En mi zona')}
                              className="w-full text-left px-3 py-2 hover:bg-gray-100 rounded-lg text-sm flex items-center gap-2 transition-colors"
                            >
                              <Send className="w-5 h-5 text-gray-400" />
                              <span className="text-2xl">En la zona</span>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </PopoverContent>
                </Popover>

                {/* Check-in con DatePicker */}
                <Popover open={showCheckIn} onOpenChange={setShowCheckIn}>
                  <PopoverTrigger asChild>
                    <div className="flex-1 min-w-0 px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-full transition-colors">
                      <div className="flex items-center gap-2">
                        <CalendarDays className="w-4 h-4 text-gray-400 flex-shrink-0" />
                        <div className="min-w-0">
                          <div className="text-xs font-medium text-gray-900">
                            Check-in
                          </div>
                          <div className="text-sm text-gray-600 truncate">
                            {checkIn
                              ? format(checkIn, "dd MMM yyyy", { locale: es })
                              : "¿Cuándo?"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <CalendarComponent
                      mode="single"
                      selected={checkIn}
                      onSelect={handleCheckInSelect}
                      disabled={(date: any) => date < new Date()}
                      locale={es}
                    />
                  </PopoverContent>
                </Popover>


                {/* Check-out con DatePicker */}
                <Popover open={showCheckOut} onOpenChange={setShowCheckOut}>
                  <PopoverTrigger asChild>
                    <div className="flex-1 min-w-0 px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-full transition-colors">
                      <div className="flex items-center gap-2">
                        <CalendarDays className="w-4 h-4 text-gray-400 flex-shrink-0" />
                        <div className="min-w-0">
                          <div className="text-xs font-medium text-gray-900">
                            Check-out
                          </div>
                          <div className="text-sm text-gray-600 truncate">
                            {checkOut
                              ? format(checkOut, "dd MMM yyyy", { locale: es })
                              : "¿Cuándo?"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <CalendarComponent
                      mode="single"
                      selected={checkOut}
                      onSelect={handleCheckOutSelect}
                      disabled={(date: any) => date < (checkIn || new Date())}
                      locale={es}
                    />
                  </PopoverContent>
                </Popover>


                {/* Viajeros Mejorado */}
                <Popover open={showGuests} onOpenChange={setShowGuests}>
                  <PopoverTrigger asChild>
                    <div className="flex-1 min-w-0 px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-full transition-colors">
                      <div className="flex items-center gap-2">
                        <Users className="w-4 h-4 text-gray-400 flex-shrink-0" />
                        <div className="min-w-0">
                          <div className="text-xs font-medium text-gray-900">
                            Viajeros
                          </div>
                          <div className="text-sm text-gray-600 truncate">
                            {guest === 1
                              ? "1 huésped"
                              : `${guest} huéspedes`}
                          </div>
                        </div>
                      </div>
                    </div>
                  </PopoverTrigger>
                  <PopoverContent className="w-80 p-4" align="end">
                    <div className="space-y-6">
                      {/* Adultos */}
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-medium">Huéspedes</div>
                          <div className="text-sm text-gray-600">
                          </div>
                        </div>
                        <div className="flex items-center gap-3">
                          <Button
                            variant="outline"
                            size="icon"
                            className="h-8 w-8 rounded-full"
                            onClick={() => setGuest(Math.max(1, guest - 1))}
                            disabled={guest <= 1}
                          >
                            <Minus className="w-4 h-4" />
                          </Button>
                          <span className="w-8 text-center font-medium">
                            {guest}
                          </span>
                          <Button
                            variant="outline"
                            size="icon"
                            className="h-8 w-8 rounded-full"
                            onClick={() => setGuest(Math.min(16, guest + 1))}
                            disabled={guest >= 16}
                          >
                            <Plus className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>
                      <div className="pt-4 border-t">
                        <div className="text-sm text-gray-600">
                          Total:{" "}
                          <span className="font-medium">
                            {guest}{" "}
                            {guest === 1 ? "huésped" : "huéspedes"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </PopoverContent>
                </Popover>

                {/* Search Button */}
                <button
                  onClick={handleSearch}
                  className="btn w-full h-full btn-filled-2 flex"
                >
                  <span className="flex justify-center items-center">

                    <Search className="w-5 h-5 me-2" />
                    Buscar
                  </span>
                </button>
              </div>
            </Drawer.Items>
          </Drawer>
        )
      }

    </header>
  );
};

export default Header;
